import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import "./Hero.css"

const Root = styled(Box)(({ theme }) => ({
  backgroundSize: "cover",
  backgroundPosition: "center",
  height: "225px",
  marginTop: "48px",
  position: "relative",
  overflow: "hidden",
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    height: "400px",
  }
}));

const Overlay = styled(Box)(({ theme }) => ({
  backgroundColor: "black",
  opacity: 0.5,
  height: "225px",
  width: "100%",
  position: "absolute",
  top: 0,
  left: 0,
  [theme.breakpoints.up('md')]: {
    height: "400px",
  }
}));


const Hero = ({ endPoint, heroBg, textInHero }) => {
  return (
    <Root style={{ backgroundImage: `url(${endPoint}${heroBg})` }}>
      <Overlay />
      <h1 className='textInHero'>{textInHero}</h1>
    </Root>
  );
};


export default Hero;
